// extracted by mini-css-extract-plugin
module.exports = {"container":"no-villas-found-module__container___AvRp+","icon":"no-villas-found-module__icon___1lXzy","header":"no-villas-found-module__header___cYJvb"};